import React from 'react'
import styled from 'styled-components';
import { useLanguage } from '../../utils/LanguageContext';

const Card = styled.div`
width: 650px;
border-radius: 10px;
box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
padding: 12px 16px;
justify-content: space-between;
position: relative;
overflow: hidden;
display: flex;
flex-direction: column;
gap: 12px;
transition: all 0.3s ease-in-out;
height: 100%;

&:hover{
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    transform: translateY(-5px);
}

@media (max-width: 768px){
    padding: 10px;
    gap: 8px;
    width: 100%;
    margin-left: 20px;

}

border: 0.1px solid #306ee8;
box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
`;

const Top = styled.div`
display: flex;
gap: 12px;
width: 100%;
`;

const LogoAvatar = styled.div`
height: 50px;
width: 50px;
min-width: 50px;
border-radius: 10px;
margin-top: 4px;
display: flex;
align-items: center;
justify-content: center;
font-size: 22px;
font-weight: 700;
color: #fff;
background: linear-gradient(135deg, #854CE6 0%, #6a1bb3 100%);

@media (max-width: 768px) {
    height: 40px;
    width: 40px;
    min-width: 40px;
    font-size: 18px;
}
`;

const Body = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const Role = styled.div`
font-size: 18px;
font-weight: 600;
color: ${({ theme }) => theme.text_primary + 99};

@media (max-width: 768px) {
    font-size: 16px;
}
`;

const Company = styled.div`
font-size: 16px;
font-weight: 500;
color: ${({ theme }) => theme.text_secondary + 99};

@media (max-width: 768px) {
    font-size: 14px;
}
`;

const Duration = styled.div`
font-size: 12px;
font-weight: 400;
color: ${({ theme }) => theme.text_secondary + 80};

@media (max-width: 768px) {
    font-size: 12px;
}
`;

const Description = styled.div`
width: 100%;
font-size: 15px;
font-weight: 400;
color: ${({ theme }) => theme.text_primary + 99};
margin-bottom: 10px;

@media (max-width: 768px){
    font-size: 14px;
    line-height: 1.5;
}
`;

const Skills = styled.div`
width: 100%;
display: flex;
gap: 12px;
margin-top: 10px;
`;

const ItemWrapper = styled.div`
display: flex;
flex-wrap: wrap;
gap: 8px;
`;

const Skill = styled.div`
font-size: 15px;
font-weight: 400;
color: ${({ theme }) => theme.text_primary + 99};

@media (max-width: 768px){
    font-size: 12px;
}
`;

const DocLink = styled.a`
font-size: 13px;
color: ${({ theme }) => theme.primary};
text-decoration: none;
margin-top: 4px;
display: flex;
align-items: center;
gap: 4px;
&:hover {
    text-decoration: underline;
}
`;

const getInitials = (company) => {
  if (!company) return "?";
  const words = company.split(",")[0].split(" ");
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

const ExperienceCard = ({ experience }) => {
  const { language } = useLanguage();
  const role = typeof experience.role === 'object' ? experience.role[language] : experience.role;
  const date = typeof experience.date === 'object' ? experience.date[language] : experience.date;
  const desc = typeof experience.desc === 'object' ? experience.desc[language] : experience.desc;

  return (
    <Card>
      <Top>
        <LogoAvatar aria-label={experience.company}>
          {getInitials(experience.company)}
        </LogoAvatar>
        <Body>
          <Role>{role}</Role>
          <Company>{experience.company}</Company>
          <Duration>{date}</Duration>
        </Body>
      </Top>
      <Description>
        {desc}
        {experience?.skills && (
          <>
            <br />
            <Skills>
              <b>Skills:</b>
              <ItemWrapper>
                {experience.skills.map((skill, index) => (
                  <Skill key={index}>• {skill}</Skill>
                ))}
              </ItemWrapper>
            </Skills>
          </>
        )}
      </Description>
      {experience.doc && (
        <DocLink href={experience.doc} target="_blank" rel="noopener noreferrer">
          ↗ View Company
        </DocLink>
      )}
    </Card>
  )
}

export default ExperienceCard
